<ng-template #imagesTemplate let-rowAlign="rowAlign">
	@if (images(); as images) { @if (images && images.length) {
	<div libFlexRow [libFlexRowGap]="'16px'" [libFlexRowAlign]="rowAlign">
		@for (image of images; track image.image.originalImage.absoluteUrl) {
		<div libFlexColumn>
			<lib-image
				[alt]="image.title ?? 'Card image'"
				class="card-image"
				[priority]="imagePriority()"
				[dialogPreviewImage]="image.image"
				[isResponsive]="false"
				[isRound]="roundCardImages()"
				[image]="image.image"
				[imageSize]="'50px'"
			></lib-image>
		</div>
		}
	</div>
	} }
</ng-template>

<ng-template #contentTemplate>
	<ng-content></ng-content>
</ng-template>

@if (enableCard()) {
<div
	class="ui-card"
	[class.design-default]="cardDesign() === 'default'"
	[class.design-clean]="cardDesign() === 'clean'"
	[class.design-selection]="cardDesign() === 'selection'"
	[class.design-primary-light]="cardDesign() === 'primaryLight'"
	[class.isInDialog]="isInDialog()"
	[class.removePadding]="removePadding()"
	[class.removeBottomPadding]="removeBottomPadding()"
	[class.mobile]="isMobileView()"
	[class.collapsible]="isCollapsible() && isCollapsed()"
	(click)="handleCollapsed($event, 'card')"
>
	@if (showCardToolbar()) {
	<div
		(click)="handleCollapsed($event, 'title')"
		[class.collapsible-row]="isCollapsible()"
		libFlexRow
		[libFlexRowAlign]="'center'"
		[libFlexRowGap]="'16px'"
		[class.push-bottom]="addCardToolbarBottomMargin()"
	>
		@if (imagesLocation() === 'default' && images()?.length) {
		<div libFlexColumn>
			<ng-template
				[ngTemplateOutlet]="imagesTemplate"
				[ngTemplateOutletContext]="{ rowAlign: 'center' }"
			></ng-template>
		</div>

		} @if (cardIcon(); as cardIcon) {
		<div libFlexColumn>
			<lib-icon [type]="cardIcon"></lib-icon>
		</div>
		} @if (avatar(); as avatar) {
		<div libFlexColumn>
			<lib-image
				[alt]="'Card avatar'"
				[class.editableAvatar]="isEditableAvatar()"
				(click)="handleAvatarClick()"
				[priority]="imagePriority()"
				[maxWidth]="calculatedAvatarWidthAndHeight()"
				[maxHeight]="calculatedAvatarWidthAndHeight()"
				[image]="avatar"
				[imageSize]="'50px'"
			></lib-image>
		</div>
		} @if (!avatar() && avatarName()) {
		<div libFlexColumn>
			<lib-image
				[alt]="'Card editable avatar'"
				[class.editableAvatar]="isEditableAvatar()"
				(click)="handleAvatarClick()"
				[priority]="imagePriority()"
				[maxWidth]="calculatedAvatarWidthAndHeight()"
				[maxHeight]="calculatedAvatarWidthAndHeight()"
				[avatarName]="avatarName()"
				[image]="undefined"
				[imageSize]="'50px'"
			></lib-image>
		</div>
		} @if (titlePrefix(); as titlePrefix) {
		<div libFlexColumn libText3>
			{{ titlePrefix }}
		</div>
		}
		<div libFlexColumn libFlexFill>
			@if (titleTemplate(); as titleTemplate) {
			<ng-container [ngTemplateOutlet]="titleTemplate"></ng-container>
			} @else if (title(); ) {
			<div>
				@if (titleSize() === 'h1') {
				<h1>{{ title() }}</h1>
				} @else if (titleSize() === 'h2') {
				<h2>{{ title() }}</h2>
				} @else if (titleSize() === 'h3') {
				<h3>{{ title() }}</h3>
				} @else {
				<h4>{{ title() }}</h4>
				}
			</div>
			} @if (isCollapsible()) {
			<div libText3>
				{{ !isCollapsed() ? 'Click to hide' : 'Click to expand' }}
			</div>
			} @else if (subtitle()) {
			<div libText3 class="push-top-xs subtitle">
				{{ subtitle() }}
			</div>
			}
		</div>

		@if (titleSuffix(); as titleSuffix) {
		<div libFlexColumn libText3>
			{{ titleSuffix }}
		</div>
		} @if (pieGraph(); as pieGraph) {
		<div libFlexColumn>
			<lib-pie-chart
				[view]="[40, 40]"
				[showLabels]="false"
				[singleSeries]="pieGraph.singleSeries"
				[colorScheme]="pieGraph.colorScheme"
			></lib-pie-chart>
		</div>
		} @if (imagesLocation() === 'end' && images()?.length) {

		<div libFlexColumn>
			<ng-template
				[ngTemplateOutlet]="imagesTemplate"
				[ngTemplateOutletContext]="{ rowAlign: 'center' }"
			></ng-template>
		</div>

		} @if (buttons(); as buttons) { @if (buttons && buttons.length) {
		<div class="buttons-container">
			<lib-button-list
				[extendListThreshold]="buttonsExtendedListThreshold()"
				[buttons]="buttons"
				[mode]="buttonsMode()"
				[moreIcon]="buttonsMoreIcon()"
			></lib-button-list>
		</div>
		} } @if (isCollapsible()) {
		<div libFlexColumn>
			<lib-button [iconOnly]="true" [icon]="isCollapsed() ? 'chevronRight' : 'chevronDown'"></lib-button>
		</div>
		}
	</div>
	} @if (!isCollapsed()) {
	<!---->
	@if (imagesLocation() === 'below' && images()?.length) {
	<div class="push-top">
		<ng-template
			[ngTemplateOutlet]="imagesTemplate"
			[ngTemplateOutletContext]="{ rowAlign: 'start' }"
		></ng-template>
	</div>
	} @if (addContentDivider()) {
	<lib-divider class="push-bottom push-top"></lib-divider>

	}

	<div [class.push-top]="addCardToolbarMargin() && !addContentDivider()">
		<ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
	</div>
	}
</div>
} @else {
<ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
}
